import { isTenantScopeGrant } from "../../../../shared/rbac/permissions";

type Grant = {
  id: string;
  scopeId: string;
  tenantId?: string | null;
  builtinRoleId: string | null;
  customRoleId: string | null;
};

type GroupWithGrants = {
  id: string;
  roleGrantsAsPrincipal: readonly Grant[];
};

export function collectEffectiveGrants(
  directGrants: readonly Grant[],
  groups: ReadonlyMap<string, GroupWithGrants>,
  excludeScopeIds?: readonly string[]
): Grant[] {
  const excluded = new Set<string>(excludeScopeIds ?? []);
  const isExcluded = (g: Grant) =>
    isTenantScopeGrant(g) || excluded.has(g.scopeId);

  const direct = directGrants.filter((g) => !isExcluded(g));

  const inherited = directGrants.flatMap((g) => {
    const group = groups.get(g.scopeId);
    return group?.roleGrantsAsPrincipal ?? [];
  });

  const seen = new Set(direct.map((g) => g.id));
  return [
    ...direct,
    ...inherited.filter((g) => !seen.has(g.id) && !isExcluded(g)),
  ];
}
